import { render, staticRenderFns } from "./serviceTimeCriticality.vue?vue&type=template&id=135967bd&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./serviceTimeCriticality.vue?vue&type=style&index=0&id=135967bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135967bd",
  null
  
)

export default component.exports